import React from 'react';
import "../../styles/chats/display_chats.css";
import profileImage from "../../images/authentication/no_profile.png";
import { useSearchContext } from './searchContext';
import { Link } from 'react-router-dom';

const DisplayChats = ({displayConUserImage, displayConUsername, displayLastMessage, id }) => {
    const {setUserId} = useSearchContext();

    const onSelectChat = () => {
        setUserId(id);
    };

    return(
        <Link className="action_container_sub_home_screen_b" to={id === "" || id == null ? null : `/main_back/chats/${displayConUsername}`}><div onClick={onSelectChat} className="display_chats_tab">
            <img alt='profile' className="display_chats_tab_user_image" src={displayConUserImage === "" || displayConUserImage === null ? profileImage : displayConUserImage} />
            <p className="display_chats_tab_user_name" >{displayConUsername}</p>
            <p className="display_chats_tab_last_message">{displayLastMessage}</p>
        </div></Link>
    );
};

export default DisplayChats;